import useTranslation from "@/hooks/useTranslation";
import { PRODUCT_BY, ProductBy } from "@/pages/dashboard/hooks/useProductImpact";
import { ImpactMetric } from "@/pages/dashboard/utils/types";
import { Segmented, Tabs } from "antd";
import { useState } from "react";
import Widget from "../../../components/Widget/Widget";
import CategoryImpactPerLifeCycle from "./CategoryImpactPerLifeCycle";
import CategoryImpactPerScope from "./CategoryImpactPerScope";

export type FacilityImpactDetailMode = "Absolute" | "Relative (%)";
export type TabKey = "per_category" | "life_cycle";

export default function CategoryImpactSideBySide({ metric }: { metric: ImpactMetric }) {
  const translation = useTranslation();
  const [mode, setMode] = useState<FacilityImpactDetailMode>("Absolute");
  const [by, setBy] = useState<ProductBy>("total");
  const [key, setKey] = useState<TabKey>("life_cycle");

  const items = [
    {
      key: "life_cycle",
      label: "Life cycle phase",
      children: (
        <CategoryImpactPerLifeCycle
          metric={metric}
          mode={mode}
          by={by}
        />
      ),
    },
  ];

  if (metric.key === "carbon_footprint") {
    items.push({
      key: "scope",
      label: "Impact scope",
      children: (
        <CategoryImpactPerScope
          by={by}
          mode={mode}
        />
      ),
    });
  }

  return (
    <Widget
      title={"Impact per product category"}
      tooltip={translation["dashboard"]["product"]["per_product"]}
      topRight={
        <>
          <Segmented
            options={PRODUCT_BY}
            onChange={setBy}
            value={by}
          />
          <Segmented
            options={["Absolute", "Relative (%)"]}
            onChange={setMode}
          />
        </>
      }
    >
      <Tabs
        onChange={(key) => setKey(key as TabKey)}
        activeKey={key}
        items={items}
      />
    </Widget>
  );
}
